"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var parseSwaggerDocumentation_1 = require("./parseSwaggerDocumentation");
exports.parseSwaggerDocumentation = parseSwaggerDocumentation_1.default;
tslib_1.__exportStar(require("./parseSwaggerDocumentation"), exports);
//# sourceMappingURL=index.js.map